export default __webpack_public_path__ + "static/media/basic-regular.aef1fb15.png";